<template>
  <div class="change-data-wrapper">
    <el-table :data="data" border style="width: 100%" header-row-class-name="headerTable"
      :cell-style="{ padding: '8px 0' }">
      <el-table-column prop="status" label="类型" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status === 'change'" size="small">变更</el-tag>
          <el-tag type="success" v-else-if="scope.row.status === 'add'" size="small">新增</el-tag>
          <el-tag type="danger" v-else size="small">删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="物料名称" align="center">
        <template slot-scope="scope">
          <span class="material-name">{{ scope.row.materialName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="specs" label="规格" align="center">
        <template slot-scope="scope">
          <span class="material-name">{{ scope.row.specs || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialNumber" label="变更前数量" align="center">
        <template slot-scope="scope">
          <span :class="{'value-changed': scope.row.materialNumber !== scope.row.changeNumber}">
            {{ scope.row.materialNumber || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="changeNumber" label="变更后数量" align="center">
        <template slot-scope="scope">
          <span :class="{'value-changed': scope.row.materialNumber !== scope.row.changeNumber}">
            {{ scope.row.changeNumber || '-' }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>


import {getMaterialType} from "@/api/dilivery/material/lexicon";

export default {
  name: "MaterialsChangeData",
  components: {},
  props: {
    oldData:{
      default:()=>([])
    },
    newData:{
      default:()=>([])
    },
  },
  data(){
    return{
      data:[],
      table:[],
      LexiconOptions:[],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
    }
  },
  computed: {
  },
  mounted() {
    this.getLexiconOptions()
  },
  methods: {
    async getLexiconOptions() {
      try {
        let param = {
          'type': 'PROTECT_REAGENT'
        }
        const res = await getMaterialType(param)
        if (res.code === 200) {
          this.LexiconOptions = res.data.map(item => {
            return {
              materialId:item.id,
              materialName:item.materialName
            }
          })
        }
        this.getMaterialData()
      } catch (error) { console.log(error); }
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData() {
      this.page.total = this.table.length
      // 计算当前页的起始索引
      const startIndex = (this.page.currentNum - 1) * this.page.pageSize;
      // 返回当前页的数据
      this.data = this.table.slice(startIndex, startIndex + this.page.pageSize);
    },
    getMaterialData() {
      try {
        const arr1 = [...this.oldData]
        const arr2 = [...this.newData]
        const map = new Map()
        // 以 oldData 为基础，使用 id + specs 作为复合键值
        arr1.forEach(item => {
          const key = `${Number(item.materialId)}_${item.specs || ''}`
          map.set(key, {
            materialId: Number(item.materialId),
            materialName: item.materialName,
            specs: item.specs || '',
            materialNumber: item.materialNumber,
            changeNumber: '',
            status: 'delete',
          })
        })
        // 遍历 newData，按复合键值匹配
        arr2.forEach(item => {
          const key = `${Number(item.materialId)}_${item.specs || ''}`
          if (map.has(key)) {
            const existingItem = map.get(key)
            // id和规格均一致，检查数量是否变化
            if (Number(existingItem.materialNumber) === Number(item.materialNumber)) {
              // 数量也一致，说明该条数据未变化，不展示
              map.delete(key)
            } else {
              // 数量不同，说明信息进行了变更
              map.set(key, {
                ...existingItem,
                changeNumber: item.materialNumber,
                status: 'change',
              })
            }
          } else {
            // 不存在该复合键值，说明是新增物料
            map.set(key, {
              materialId: Number(item.materialId),
              materialName: item.materialName,
              specs: item.specs || '',
              materialNumber: '',
              changeNumber: item.materialNumber,
              status: 'add',
            })
          }
        })
        // 合并物料名称
        const mapValues = Array.from(map.values())
        const lexiconMap = new Map(this.LexiconOptions.map(l => [Number(l.materialId), l.materialName]))
        this.table = mapValues.map(item => ({
          ...item,
          materialName: item.materialName || lexiconMap.get(item.materialId) || '',
        }))
        this.getData()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.change-data-wrapper {
  ::v-deep .headerTable th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #303133;
  }
}

.material-name {
  font-weight: 500;
  color: #409eff;
}

.value-changed {
  color: #f56c6c;
  font-weight: 500;
}

.empty-data {
  text-align: center;
  padding: 20px;
  color: #909399;
}
</style>
